import { SignupForm } from "services/cms/models";

import type { ResolvedRichText } from "./richTextResolver";
import richTextResolver from "./richTextResolver";

export interface ResolvedSignupForm {
    title?: string;
    text?: string;
    terms: ResolvedRichText;
    buttonText: string;
    inputPlaceholder: string;
    inputLabel?: string;
    successTitle: string;
    successBody: string;
    errorTitle: string;
    errorBody: string;
    errorTryAgainText: string;
    validationErrorMessage: string;
}

const signupFormResolver = (data: SignupForm): ResolvedSignupForm => {
    const signupFormData = {
        title: data.elements.title.value,
        terms: richTextResolver({
            html: data.elements.terms?.value,
            linkedItems: data.elements.terms?.linkedItems,
        }),
        buttonText: data.elements.buttonText.value,
        inputPlaceholder: data.elements.inputPlaceholder.value,
        successTitle: data.elements.successTitle.value,
        successBody: data.elements.successBody.value,
        errorTitle: data.elements.errorTitle.value,
        errorBody: data.elements.errorBody.value,
        errorTryAgainText: data.elements.errorTryAgainText.value,
        validationErrorMessage: data.elements.validationErrorMessage.value,
    } as ResolvedSignupForm;

    if (data.elements?.text?.value) {
        signupFormData.text = data.elements.text.value;
    }

    if (data.elements?.inputLabel?.value) {
        signupFormData.inputLabel = data.elements.inputLabel.value;
    }

    return signupFormData;
};

export default signupFormResolver;
